import wSelect from './w-select.vue'
import wSelectSimple from './w-select-simple.vue'
import wSelectBeauty from './extra/w-beauty-select'
import wSelectBeauty2 from './extra/w-beauty-select2'
import wInput from './w-input.vue'
import wTextarea from './w-textarea.vue'
import wTextareaCount from './w-textarea-count.vue'
import wFile from './w-file'
import wFileImage from './w-file-image'

export default {
	select: wSelect,
	selectSimple: wSelectSimple,
	input: wInput,
	textarea: wTextarea,
	textareaCount: wTextareaCount,
	file: wFile,
	fileImage: wFileImage,
	extraSelect: wSelectBeauty,
	extraSelect2: wSelectBeauty2,
};
